import React, { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory } from 'react-router-dom';
import block from 'bem-cn';

import Spinner from 'components/Spinner/view/desktop';

import usePlayersDeposits from 'features/reports/model/playerDeposits/usePlayersDeposits';
import FilterBlock from './FilterBlock';
import Requisite from './Requisite';
import Table from './Table';

import './PlayerDeposits.scss';

const b = block('player-deposits');

const PlayerDeposits = () => {
  const history = useHistory();
  const model = usePlayersDeposits();

  const { actionProcessing } = useSelector(state => state.reports, shallowEqual);
  const semiAutoWithdrawalEnabled = useSelector(state => state.auth.semiAutoWithdrawalEnabled);

  // useEffect(() => {
  //   if (!semiAutoWithdrawalEnabled) {
  //     history.push('/');
  //   }
  // }, [semiAutoWithdrawalEnabled, history]);
  // if (!semiAutoWithdrawalEnabled) {
  //   return <Spinner isLoading={actionProcessing} />;
  // }

  if (!semiAutoWithdrawalEnabled) {
    return (
      <div className={b()}>
        <Spinner isLoading={actionProcessing} />
        <Requisite />
      </div>
    );
  }
  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <FilterBlock model={model} />
      <Requisite />
      <Table model={model} />
    </div>
  );
};

export default PlayerDeposits;
